import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse } from '@/types/api'

import type { MeuAvisoFerias } from '../types/avisoFerias'

export const meusAvisosFeriasApi = {
  /** Só os avisos já liberados, do colaborador logado (identificado pelo token). */
  list: async (): Promise<MeuAvisoFerias[]> =>
    unwrap(await httpClient.get<ApiResponse<MeuAvisoFerias[]>>('/meus-avisos-ferias')),
}
